import { CrudTableSubTableProps } from "../../../../general/modules/commons/crud/crudTableModel";
import { PositionTireSetModel } from "../../domain/models/positionTireSetModel";
import LicensePlate from "license-plate";
import { HashLink } from "react-router-hash-link";
import licencePlateSelectBg from "../../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";

export const PositionTireSetsCol = ({ row, t }: CrudTableSubTableProps) => {
  const tireSets = row.original.tiresets as PositionTireSetModel[] | undefined;
  return (
    <div className="position-tiresets-col">
      {tireSets?.map((tireSet) => {
        const plate = new LicensePlate(tireSet.car.licence ?? "");
        return (
          <HashLink
            to={"/car/" + tireSet.car?.id + "/edit#tireset-" + tireSet.id}
            key={tireSet.id}
            className="d-flex align-items-center gap-1"
          >
            {tireSet.car.licence && (
              <div className="d-flex align-items-center gap-1 mb-1">
                <div
                  className={"tireset-table-licence-plate"}
                  style={{
                    background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
                  }}
                >
                  <div>
                    {plate.valid() ? plate.pretty() : tireSet.car.licence}
                  </div>
                </div>

                <div>{tireSet.car.label}</div>

                {tireSet.car.freestock_tire && (
                  <span className="badge text-bg-secondary">
                    {t("Free stock")}
                  </span>
                )}

                {tireSet.type && (
                  <div>
                    {tireSet.car.label != "" ? ", " : ""}
                    {t(tireSet.type ?? "")}
                  </div>
                )}

                {tireSet.car.relation.name && (
                  <div>, {tireSet.car.relation.name}</div>
                )}

                {tireSet.in_hotel && (
                  <div className={"badge bg-in-hotel text-success badge-sm"}>
                    {t("In hotel")}
                  </div>
                )}
              </div>
            )}
          </HashLink>
        );
      })}
      {/* </tbody>
      </table> */}
    </div>
  );
};
